import * as React from 'react';
import './spinner.scss';

interface SpinnerProps {
    className?: string;
    size?: number;
}

// tslint:disable-next-line:max-line-length
const spinnerPath: string = 'M107.8,596.4l-45.5,42c-9.1,6.3-18.9-2.8-20.3-9.1L1.4,470.4c-6.3-23.1,11.2-34.3,25.9-30.8l172.9,35 c11.2,2.8,11.2,13.3,3.5,21.7l-40.6,39.9c47.6,51.1,116.2,82.6,191.1,82.6c141.4,0,257.6-111.3,264.6-250.6 c0-5.6,2.1-12.6,13.3-12.6h58.8c0,0,9.8,0.7,9.1,14C692.3,553,540.4,700,354.2,700C257.6,700,170.1,660.1,107.8,596.4z M9.1,344.4 c0,0-9.8-0.7-9.1-13.3C7.7,147,159.6,0,345.1,0c97.3,0,184.8,39.9,247.1,103.6l44.8-42c9.8-6.3,19.6,2.8,21,9.1l40.6,158.9 c6.3,23.1-11.2,34.3-25.9,30.8l-173.6-35c-10.5-2.8-10.5-13.3-3.5-21.7l41.3-39.9c-48.3-51.1-116.2-82.6-191.8-82.6 c-140.7,0-256.9,111.3-263.9,250.6c0,5.6-2.1,12.6-13.3,12.6H9.1z';

const Spinner = (props: SpinnerProps): JSX.Element => {
    const { className, size } = props;

    return (
        <div className="spinner-container">
            <svg
                className={`spinner ${className || ''}`}
                preserveAspectRatio="xMidYMid meet"
                width={size}
                height={size}
                viewBox="0 0 700 700"
            >
                <path d={spinnerPath} />
            </svg>
        </div>
    );
};

export { Spinner };
export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/spinner.tsx